import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { customAxiosInstance } from '../axios/axiosInstance';
import { IError } from '../interfaces/IError';
import { IVerifyUserIdsRepository } from '../interfaces/IVerifyUserIdsRepository';
import { axiosErrorHandler } from '../axios/axiosError';
import { VerifyUserIdsApi, VerifyUserIdsRequest, VerifyUserIdsResponseResult } from '../axios/generated/registerBusinessManage/api';

/**
 * ユーザーID（メール）の存在確認Repository実装
 */
export class VerifyUserIdsRepository implements IVerifyUserIdsRepository {
  /**
   * ユーザーID（メール）の存在確認をまとめて実行する
   * @param request - 確認するユーザーID（メール）の配列
   * @returns existingUserIds/notFoundUserIds を含む結果
   */
  async verify(request: VerifyUserIdsRequest): Promise<INetworkResult<VerifyUserIdsResponseResult, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    try {
      const api = new VerifyUserIdsApi(undefined, undefined, axiosInstance);
      const apiResponse = await api.verifyUserIdsPost(request);
      switch (apiResponse.status) {
        case 200: {
          const result: VerifyUserIdsResponseResult = apiResponse.data['result'];
          return { status: { type: 'success', data: result } };
        }
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }
}
